import Vue from "vue";
import Vuex from "vuex";
import { Fanbase } from "@/services/Fanbase";
const f = new Fanbase();

Vue.use(Vuex);
/* eslint-disable */

export default new Vuex.Store({
  state: {
    isLoadingActive: false,
    prjName: "",
    domainName: "",
    surveyStruct: {},
    project: {},
    currentChapter: 0,
    qtProjNumber: 0,
    nomeTwo: "",
    currentReq: 0,
    votingResult: [],
    lastReq: 0,
    startNextReq: false,
    surveyUserId: "",
    TermsAccepted: false,
    TermsText: "",
    qtUsers: 0,
    qtProjNumber: 0,
    userId: "",
    answers: [],
    endSurvey: '',
    template: {},
    surveyAtivo: false,
    registration: {
      surveyUserId: null,
      identity: null,
      code: ''
    },
    inviteName: null,
    invite: null,
    urlType10: '',
    regulationText: null,

    prizeDrawn: {
      drawDate: '',
      drawTime: '',
      winners: []
    },
    savedPhoneCode: '',
    savedPhoneNumber: '',
    savedCountry: '',
    countries: [],
  },
  mutations: {
    SET_prizeDrawn(state, value) {
      state.prizeDrawn = value;
    },
    SET_Terms(state, t) {
      state.TermsText = t;
    },
    SET_Regulation(state, t) {
      state.regulationText = t;
    },
    SET_isLoadingActive(state, val) {
      state.isLoadingActive = val;
    },
    SET_Project(state, p) {
      state.project = p;
    },
    SET_QtUsers(state, v) {
      state.qtUsers = v;
    },
    SET_QtsomosProjNumber(state, v) {
      state.qtProjNumber = v;
    },
    SET_UserId(state, v) {
      state.userId = v;
    },
    SET_urlCompleteHomeType10(state, v) {
      state.urlType10 = v;
    },
    SET_StarNextReq(state, v) {
      state.startNextReq = v;
    },
    SET_TermsAccepted(state, v) {
      state.TermsAccepted = v;
    },

    SET_Answer(state, v) {
      state.answers[v.questid] = v.value;
    },
    SET_SurveyUserId(state, s) {
      state.surveyUserId = s;
    },
    SET_SurveyStruct(state, s) {
      state.surveyStruct = s;
    },
    SET_Chapter(state, val) {
      state.currentChapter = val;
    },
    SET_Req(state, val) {
      state.currentReq = val;
    },
    SET_VotingResult(state, val) {
      state.votingResult = val;
    },
    SET_Name(state, name) {
      state.nomeTwo = name;
    },
    SET_LastReq(state, val) {
      state.lastReq = val;
    },

    SET_PrjName(state, value) {
      state.prjName = value
    },
    SET_DomainName(state, value) {
      state.domainName = value
    },
    SET_Template(state, value) {
      state.template = value
    },
    SET_surveyAtivo(state, value) {
      state.surveyAtivo = value
    },
    SET_EndSurvey(state, value) {
      state.endSurvey = value
    },

    SET_RegistrationCode(state, value) {
      state.registration.code = value
    },
    SET_RegistrationSurveyUserId(state, value) {
      state.registration.surveyUserId = value
    },
    SET_RegistrationIdentity(state, value) {
      state.registration.identity = value
    },
    SET_Invite(state, value) {
      state.invite = value
    },
    SET_InviteName(state, value) {
      state.inviteName = value
    },
    SET_COUNTRIES(state, countries) {
      state.countries = countries
    },
    SET_SavedPhoneCode(state, payload) {
      state.savedPhoneCode = payload;
    },
    SET_SavedPhoneNumber(state, payload) {
      state.savedPhoneNumber = payload;
    },
    SET_SavedCountry(state, payload) {
      state.savedCountry = payload;
    }
  },
  actions: {
    get_PrjTemplate({ commit }, { prj, domain }) {
      commit('SET_PrjName', prj)
      commit('SET_DomainName', domain)

      return f.getTemplate(prj, domain).then(
        (resp) => {
          let embedOnly = resp.data.survey.embedOnly;
          if (embedOnly !== null && embedOnly === true) {

            let redirectUrl = resp.data.survey.redirectUrl;

            let urlParams = window.location.href;

            let paramAuthToken = urlParams.includes("authToken") ? true : false;

            if (paramAuthToken == false || paramAuthToken != true)
              window.location.href = redirectUrl;
          }
          commit('SET_Template', resp.data)
        },
        (err) => alert('Houve um erro ao carregar o template \n\n' + err)
      );
    },
    get_templateByFullDomain({ commit }, { fullDomain }) {
      return f.getTemplateByFullDomain(fullDomain).then(
        (resp) => {
          let embedOnly = resp.data.survey.embedOnly;
          if (embedOnly !== null && embedOnly === true) {

            let redirectUrl = resp.data.survey.redirectUrl;

            let urlParams = window.location.href;

            let paramAuthToken = urlParams.includes("authToken") ? true : false;

            if (paramAuthToken == false || paramAuthToken != true)
              window.location.href = redirectUrl;
          }
          commit('SET_Template', resp.data)
        },
        (err) => {
          console.log('Houve um erro ao carregar o template pelo domínio completo \n\n' + err)
          throw new Error(err)
        }
      );
    },
    set_endSurvey({ commit }, payload) {
      commit('SET_EndSurvey', payload)
    },
    set_isLoadingActive({ commit }, val) {
      commit('SET_isLoadingActive', val)
    },
    setCountries({ commit }, countries) {
      commit('SET_COUNTRIES', countries)
    },
    clearSavedFields({ commit }) {
      commit("SET_SavedPhoneCode", "");
      commit("SET_SavedPhoneNumber", "");
      commit("SET_savedCountry", "");
    }
  },
  getters: {
    answerValue: (state) => (qId) => {
      return state.answers[qId];
    },
    getRegistrationCode: (state) => {
      return state.registration.code
    },
    getHeaderTemplate: (state) => {
      return state.template && state.template.header ? state.template.header : {}
    },
    getPrizeDrawn: (state) => {
      return state.prizeDrawn
    },
    getDrawDate: (state) => {
      return state.prizeDrawn.drawDate
    },
    getDrawTime: (state) => {
      return state.prizeDrawn.drawTime
    },
    getDrawWinners: (state) => {
      return state.prizeDrawn.winners
    },
    getCountries: state => state.countries,
  },
});

//export default store
